export default {
  COOKIE_DETAILS: 'cookieDetails',
  DOC_MODAL: 'docModal',
  GACM_DETAILS: 'gacmDetails',
  PREFERENCES: 'preferences',
  PROMPT: 'prompt',
  TCF_DETAILS: 'tcfDetails',
}
